import {
  MemberResponsibleGamingEnd,
  MemberResponsibleGamingLimitsCard,
  MemberResponsibleGamingLimitsTable,
  MemberResponsibleGamingSelfLimitsTable
} from '@bo-components/members/memberResponsibleGaming';
import { MemberFetchStatus } from '@bo-components/members';
import { NoResults } from '@library/components/NoResults';
import { useMemberDetails } from '@bo-hooks/members/useMemberDetails';

export const MemberResponsibleGaming = () => {
  const { isError, isLoading, memberProfile } = useMemberDetails();

  const isMemberNotFound = !memberProfile;

  if (isError || isLoading || isMemberNotFound) {
    return (
      <MemberFetchStatus
        isError={isError}
        isLoading={isLoading}
        isMemberNotFound={isMemberNotFound}
      />
    );
  }

  const {
    limits: {
      depositLimitAmounts,
      depositLimitRestrictionEndDate,
      lineupLimitAmounts,
      lineupLimitCounts,
      lineupLimitRestrictionEndDate,
      selfLimits
    }
  } = memberProfile;

  const hasLineupLimits = lineupLimitAmounts.length || lineupLimitCounts.length;
  const hasDepositLimits = !!depositLimitAmounts.length;
  const hasSelfLimits = !!selfLimits.length;

  if (!hasLineupLimits && !hasDepositLimits && !hasSelfLimits) {
    return (
      <section className="p-6">
        <NoResults
          label="Currently member does not have any Limits or Self Exclusion or Self Timeout"
          title="No Limits"
          dataTestId="no-limits-card"
        />
      </section>
    );
  }

  return (
    <section className="p-6 pt-0">
      {hasLineupLimits && (
        <div className="flex w-full items-center justify-end gap-4 pb-4 text-center text-sm">
          <MemberResponsibleGamingEnd
            endDateLabel="Lineup"
            endDateTimeValue={lineupLimitRestrictionEndDate}
          />
        </div>
      )}
      <div className="flex flex-col gap-4">
        {lineupLimitAmounts.length > 0 && (
          <MemberResponsibleGamingLimitsCard cardTitle="Lineup Amount Limits">
            <MemberResponsibleGamingLimitsTable
              memberLimits={lineupLimitAmounts}
              limitType="entry"
              limitValueType="Amount"
            />
          </MemberResponsibleGamingLimitsCard>
        )}
        {lineupLimitCounts.length > 0 && (
          <MemberResponsibleGamingLimitsCard cardTitle="Lineup Count Limits">
            <MemberResponsibleGamingLimitsTable
              memberLimits={lineupLimitCounts}
              limitType="entry"
              limitValueType="Count"
            />
          </MemberResponsibleGamingLimitsCard>
        )}
        {hasDepositLimits && (
          <>
            <div className="flex w-full items-center justify-end gap-4 text-center text-sm">
              <MemberResponsibleGamingEnd
                endDateLabel="Deposit"
                endDateTimeValue={depositLimitRestrictionEndDate}
              />
            </div>
            <MemberResponsibleGamingLimitsCard cardTitle="Deposit Limits">
              <MemberResponsibleGamingLimitsTable
                memberLimits={depositLimitAmounts}
                limitType="deposit"
                limitValueType="Amount"
              />
            </MemberResponsibleGamingLimitsCard>
          </>
        )}
        {hasSelfLimits && (
          <MemberResponsibleGamingLimitsCard cardTitle="Timeout and Exclusion">
            <MemberResponsibleGamingSelfLimitsTable selfLimits={selfLimits} />
          </MemberResponsibleGamingLimitsCard>
        )}
      </div>
    </section>
  );
};
